<template>

<com-item name="game.affinity.mechanics" :size="size" :loading="loading" :is-empty="!active" :has-more="hasMore" v-on:more="onMore" title="Mechanics">

	<template v-slot:about>

		<p>{{ your | capitalise }} track record with these mechanics.</p>

	</template>

	<template v-slot:stats>

		<com-affinity-list v-if="active" :items="items" :baselines="data.baselines" :your="your" :you="you" colour="#1a9960" v-on:select="onSelect" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comAffinityList from './AffinityList'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-affinity-list': comAffinityList
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/affinity'] },

		items: function() {

			if (!this.data || !this.data.attributes) return []
			return this.data.attributes.filter(function(a) { return a.type === 'mechanic' })

		},

		total: function() {

			return (this.data && this.data.totals) ? this.data.totals.mechanic || 0 : 0

		},

		hasMore: function() { return this.total > 5 },

		active: function() { return !this.loading && this.items.length }

	},

	methods: {

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityMechanics',
				id: parseInt(this.$route.params.game) || 0
			})

		},

		onSelect: function(item) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityAttribute',
				id: parseInt(this.$route.params.game) || 0,
				attrType: item.type,
				attrId: item.id
			})

		}

	}

}

</script>
